class UserLoginDataInvalidError extends Error{
}

export default UserLoginDataInvalidError